import { HttpClient } from '@connect-x-app/hybrid-data-access';
import { SmartAction } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

export const getSmartAction = (smartActionId: string): Promise<SmartAction> =>
  HttpClient.get<SmartAction>(API_FACTORY.v1(`admin/smart-actions/${smartActionId}`));

export const getSmartActions = (): Promise<SmartAction[]> => HttpClient.get<SmartAction[]>(API_FACTORY.v1('admin/smart-actions'));

export const createSmartAction = (smartAction: SmartAction): Promise<SmartAction> =>
  HttpClient.post(API_FACTORY.v1('admin/smart-actions'), smartAction);

export const deleteSmartAction = (id: string): Promise<SmartAction> =>
  HttpClient.delete(API_FACTORY.v1(`admin/smart-actions/${id}`));

export const updateSmartAction = (values: SmartAction): Promise<SmartAction> => {
  return HttpClient.patch(API_FACTORY.v1(`admin/smart-actions/${values.id}`), {
    apiKey: values.apiKey,
    description: values.description,
    isRequestPublic: values.isRequestPublic,
    isResponsePublic: values.isResponsePublic,
    keywords: values.keywords,
    name: values.name,
    url: values.url,
  });
};
